<nav
  id="main-header"
  class="header navbar navbar-expand-lg navbar-light transparent-header"
>
  <div class="top-section top-header-section">
    <div class="left-section"></div>
    <div class="right-section d-flex align-items-center">
      <div class="dropdown">
        <a
          class="btn nav-link user-detail dropdown-toggle"
          id="dropdownMenuButton1"
          [matMenuTriggerFor]="menu"
        >
          <span class="user-meta">
            <span class="userName">Admin</span>
            <span class="userRole">Super Admin</span>
          </span>
          <span class="avatar-wrap">
            <img
              class="user-avatar"
              width="36px"
              src="/assets/images/avatar.png"
              alt="avatar"
            />
          </span>
        </a>
      </div>
      <mat-menu #menu="matMenu" panelClass="admin-user-menu" xPosition="before">
        <button class="logout-menu-item" (click)="logout()" mat-menu-item>
          <img src="/assets/images/logout.png" width="18px" alt="logout" />
          <span>Logout</span>
        </button>
      </mat-menu>
    </div>
  </div>
</nav>
